import { render, staticRenderFns } from "./ShowProjectBookings.vue?vue&type=template&id=59a12064&scoped=true&"
import script from "./ShowProjectBookings.vue?vue&type=script&lang=js&"
export * from "./ShowProjectBookings.vue?vue&type=script&lang=js&"
import style0 from "./ShowProjectBookings.vue?vue&type=style&index=0&id=59a12064&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a12064",
  null
  
)

export default component.exports